import Vue from 'vue'

export const useErrorLogging = () => {
  const logError = (error: unknown): void => {
    const datadogRum = Vue.prototype.$datadogRum
    datadogRum?.addError(typeof error === 'string' ? new Error(error) : error)
  }

  return { logError }
}
